<template>
    <div>
       <omni-chat-enterprise></omni-chat-enterprise>
    </div>
 </template>
 
 <script>
 </script>